






import { Component, Prop, Vue } from 'vue-property-decorator';
import { TypeIcon } from './types';

@Component
export default class AppTypeIcon extends Vue {
  @Prop({ type: String, default: 'child' })
  readonly type!: TypeIcon;

  get typeClasses(): Array<string> {
    const { type } = this;
    if (!type.length) return [];
    return type.split(', ').map((item) => `type-icon_${item}`);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/icons/TypeIcon/AppTypeIcon.vue